import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import useRole from "../../auth/useRole";
import useActiveBusinessMembership from "../../hooks/useActiveBusinessMembership";
import useStore from "../../store/useStore";
import { BUSINESS_HUB_PATH, resolveBusinessGate } from "../../services/postAuthRouting";
import BusinessRequiredState from "../business/BusinessRequiredState";

export default function RequireRaffleAccess() {
  const { user, loading } = useAuth() || {};
  const { isAdmin } = useRole();
  const { userProfile } = useStore();
  const {
    membershipLoading,
    canAccessCollections,
    hasActiveBusinessContext,
    isActiveBusinessProfileLive,
  } = useActiveBusinessMembership();
  const loc = useLocation();

  if (loading) return null;
  if (!user) return <Navigate to="/signin" state={{ from: loc }} replace />;
  if (isAdmin) return <Outlet />;

  if (membershipLoading && hasActiveBusinessContext) return null;

  const featureLabel = loc.pathname.startsWith("/coupons") ? "Digital Coupons" : "Digital Raffles";
  const gate = resolveBusinessGate({
    accountType: userProfile?.accountType,
    hasActiveBusinessContext,
    isActiveBusinessProfileLive,
  });
  if (!gate.allowed) {
    return (
      <BusinessRequiredState
        reason={gate.reason}
        featureLabel={featureLabel}
        nextPath={`${loc.pathname}${loc.search || ""}`}
      />
    );
  }

  // Business is live, but this member's scope no longer includes campaign management.
  if (!canAccessCollections) {
    return <Navigate to={BUSINESS_HUB_PATH} state={{ from: loc, accessRevoked: true }} replace />;
  }

  return <Outlet />;
}
